var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-item',{attrs:{"validator":_vm.validator,"items":_vm.countries,"placeholder":"Select a Country","placeholderEmpty":"No countries found","isLoading":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }